import { TitleButton } from '@/common/buttons/TitleButton';
import { ActionDialog } from '@/common/dialog/ActionDialog';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { ValList } from '@/common/val/ValList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { AbvOverUnderScenActionSelect } from './AbvOverUnderScenActionSelect';
import { AbvOverUnderScenActionsList } from './AbvOverUnderScenActionsList';
import { AbvOverUnderScenForm } from './AbvOverUnderScenForm';
import { AbvChbkPipeOverUnderPerspective } from './chbkpipeoverunder/AbvChbkPipeOverUnderPerspective';
import { AbvMcdLiabPerspective } from './mcdLiab/AbvMcdLiabPerspective';
import { AbvOverUnderPerspective } from './overUnder/AbvOverUnderPerspective';
import { AbvPbmLiabPerspective } from './pbmLiab/AbvPbmLiabPerspective';
import { AbvRbtPipeOverUnderPerspective } from './rbtpipeoverunder/AbvRbtPipeOverUnderPerspective';

export const AbvOverUnderScenDetail = () => {
  const { entityObj } = useEntityMgr();
  const { openDialog } = useDialog();

  const module = useModuleFromRoute();
  const { hasRole } = usePrincipal();

  const augButtons = (buttons) => {
    if (entityObj.status === 'LOADING') {
      return;
    }

    const role = module.toUpperCase() + '_OVER_UNDER_SCEN_SAVE';
    if (!hasRole(`${role}`)) return;

    if (entityObj.status !== 'APPROVED') {
      buttons.push(<AbvOverUnderScenActionSelect entityId={entityObj.id}></AbvOverUnderScenActionSelect>);
    }

    buttons.push(
      <TitleButton
        toolTip={'Duplicate this Scenario'}
        icon={fas.faCopy}
        onClick={() => actionDialog('Duplicate Scenario', 'OVER_UNDER_SCEN_DUP_ACTION_PLUGIN')}
      ></TitleButton>,
    );
  };

  const actionDialog = (title, pluginCode) => {
    openDialog(ActionDialog, {
      data: {
        title,
        pluginCode,
        entity: 'OVER_UNDER_SCEN',
        entityId: entityObj.id,
      },
    });
  };

  const allTabSpecs = [
    { id: 'infoTab', label: 'Info', content: <AbvOverUnderScenForm /> },
    {
      id: 'pbmLiabTab',
      label: 'PBM Liability',
      role: 'GTN_PBM_LIAB_VIEW',
      content: <AbvPbmLiabPerspective overUnderScenId={entityObj.id} />,
    },
    {
      id: 'mcdLiabTab',
      label: 'Medicaid Liability',
      role: 'GTN_MCD_LIAB_VIEW',
      content: <AbvMcdLiabPerspective overUnderScenId={entityObj.id} />,
    },
    {
      id: 'overUnderTab',
      label: 'Base Over/(Under)',
      role: 'GTN_OVER_UNDER_VIEW',
      content: <AbvOverUnderPerspective overUnderScenId={entityObj.id} />,
    },
    {
      id: 'rbtPipeOverUnderTab',
      label: 'Rebate Pipeline Over/(Under)',
      role: 'GTN_RBT_PIPE_OVER_UNDER_VIEW',
      content: <AbvRbtPipeOverUnderPerspective overUnderScenId={entityObj.id} />,
    },
    {
      id: 'chbkPipeOverUnderTab',
      label: 'Chargeback Pipeline Over/(Under)',
      role: 'GTN_CHBK_PIPE_OVER_UNDER_VIEW',
      content: <AbvChbkPipeOverUnderPerspective overUnderScenId={entityObj.id} />,
    },
    { id: 'actionTab', label: 'Actions', content: <AbvOverUnderScenActionsList entityId={entityObj.id} /> },
    {
      id: 'valTab',
      label: 'Validations',
      role: 'GTN_VAL_VIEW',
      content: <ValList parentEntity="OVER_UNDER_SCEN" parentEntityId={entityObj.id} />,
    },
  ];

  const tabSpecs = allTabSpecs.filter((tab) => !tab.role || hasRole(tab.role)).map(({ role, ...tab }) => tab);

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
